/** Storage access that never crashes the app — falls back to in-memory when blocked. */

const memoryLocal = new Map();
const memorySession = new Map();

function store(type) {
  return type === "session" ? memorySession : memoryLocal;
}

function browserStore(type) {
  return type === "session" ? window.sessionStorage : window.localStorage;
}

export function storageAvailable(type = "local") {
  try {
    const s = browserStore(type);
    const probe = "__wecrew_probe__";
    s.setItem(probe, "1");
    s.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

export function getItem(key, type = "local") {
  try {
    const value = browserStore(type).getItem(key);
    if (value !== null) return value;
  } catch {
    /* use memory fallback */
  }
  return store(type).get(key) ?? null;
}

export function setItem(key, value, type = "local") {
  store(type).set(key, value);
  try {
    browserStore(type).setItem(key, value);
    return true;
  } catch {
    return true;
  }
}

export function removeItem(key, type = "local") {
  store(type).delete(key);
  try {
    browserStore(type).removeItem(key);
    return true;
  } catch {
    return true;
  }
}

export function clearAllBrowserStorage() {
  memoryLocal.clear();
  memorySession.clear();
  try {
    localStorage.clear();
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
}
